import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const arrowDown: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M12.594-5.5a.96.96 0 0 1-.297.703L7.219.297c-.211.195-.45.297-.719.297a.96.96 0 0 1-.703-.297L.719-4.797A.92.92 0 0 1 .422-5.5q0-.421.297-.719l.578-.578A.96.96 0 0 1 2-7.094c.281 0 .516.102.703.297L5-4.5V-10a.96.96 0 0 1 .297-.703A.96.96 0 0 1 6-11h1c.27 0 .504.102.703.297.195.2.297.433.297.703v5.5l2.297-2.297A.96.96 0 0 1 11-7.094c.27 0 .508.102.719.297l.578.578c.195.211.297.45.297.719m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(-.422 11)"
    />
  ),
  svgProps: {
    height: "11.594",
    width: "12.172",
  }
};

export const arrowLeft: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M12-5v1c0 .273-.086.508-.25.703a.82.82 0 0 1-.656.297h-5.5L7.875-.703A.94.94 0 0 1 8.172 0a.94.94 0 0 1-.297.703l-.578.594a.98.98 0 0 1-.703.297c-.274 0-.512-.102-.719-.297L.797-3.797A.95.95 0 0 1 .5-4.5q0-.404.297-.719l5.078-5.078a.99.99 0 0 1 .719-.297c.27 0 .504.102.703.297l.578.578c.195.2.297.438.297.719a.96.96 0 0 1-.297.703L5.594-6h5.5c.27 0 .488.102.656.297.164.187.25.422.25.703m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(-.5 10.594)"
    />
  ),
  svgProps: {
    height: "12.188",
    width: "11.5",
  }
};

export const arrowRight: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M11.5-4.5a.95.95 0 0 1-.281.703L6.125 1.297a.98.98 0 0 1-.703.297.96.96 0 0 1-.703-.297L4.125.719A.98.98 0 0 1 3.828 0q0-.421.297-.719L6.422-3h-5.5a.85.85 0 0 1-.672-.297A1.04 1.04 0 0 1 0-4v-1q-.001-.422.25-.703A.87.87 0 0 1 .922-6h5.5L4.125-8.297A.92.92 0 0 1 3.828-9q0-.422.297-.703l.594-.594a.96.96 0 0 1 .703-.297c.27 0 .504.102.703.297l5.094 5.094a.93.93 0 0 1 .281.703m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 10.594)"
    />
  ),
  svgProps: {
    height: "12.188",
    width: "11.5",
  }
};

export const arrowUp: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M12.594-4.422a.96.96 0 0 1-.297.703l-.578.594q-.299.298-.719.297a.92.92 0 0 1-.703-.297L8-5.422V.094c0 .27-.102.488-.297.656C7.516.914 7.281 1 7 1H6a1.06 1.06 0 0 1-.703-.25A.82.82 0 0 1 5 .094v-5.516L2.703-3.125A.92.92 0 0 1 2-2.828a.92.92 0 0 1-.703-.297l-.578-.594a.95.95 0 0 1-.297-.703.96.96 0 0 1 .297-.703l5.078-5.094A.95.95 0 0 1 6.5-10.5q.421 0 .719.281l5.078 5.094c.195.2.297.434.297.703m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(-.422 10.5)"
    />
  ),
  svgProps: {
    height: "11.5",
    width: "12.172",
  }
};

export const arrows: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M13.86-5.36Q14-5.2 14-5q0 .204-.14.344l-2 2a.5.5 0 0 1-.36.156.52.52 0 0 1-.36-.14A.52.52 0 0 1 11-3v-1H8v3h1c.133 0 .25.055.344.156.101.094.156.211.156.344q0 .204-.14.344l-2 2.015A.53.53 0 0 1 7 2a.47.47 0 0 1-.344-.14l-2-2.016A.44.44 0 0 1 4.5-.5q0-.201.14-.344A.5.5 0 0 1 5-1h1v-3H3v1a.5.5 0 0 1-.156.36.47.47 0 0 1-.344.14.44.44 0 0 1-.344-.156l-2-2A.44.44 0 0 1 0-5q-.002-.2.156-.36l2-2A.47.47 0 0 1 2.5-7.5c.133 0 .25.055.344.156C2.945-7.25 3-7.133 3-7v1h3v-3H5a.52.52 0 0 1-.36-.14.52.52 0 0 1-.14-.36q-.002-.2.156-.36l2-2A.47.47 0 0 1 7-12q.2 0 .36.14l2 2q.14.16.14.36a.5.5 0 0 1-.156.36A.47.47 0 0 1 9-9H8v3h3v-1q0-.201.14-.344a.5.5 0 0 1 .36-.156q.2 0 .36.14zm0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 12)"
    />
  ),
  svgProps: {
    height: "14",
    width: "14",
  }
};

export const arrowsHorizontal: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M13.86-5.36Q14-5.2 14-5q0 .204-.14.344l-2 2a.5.5 0 0 1-.36.156.52.52 0 0 1-.36-.14A.52.52 0 0 1 11-3v-1H3v1a.5.5 0 0 1-.156.36.47.47 0 0 1-.344.14.44.44 0 0 1-.344-.156l-2-2A.44.44 0 0 1 0-5q-.001-.2.156-.36l2-2A.47.47 0 0 1 2.5-7.5c.133 0 .25.055.344.156C2.945-7.25 3-7.133 3-7v1h8v-1q0-.201.14-.344a.5.5 0 0 1 .36-.156q.2 0 .36.14zm0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 7.5)"
    />
  ),
  svgProps: {
    height: "5",
    width: "14",
  }
};

export const arrowsVertical: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M5.36-9.86q.14.16.14.36a.5.5 0 0 1-.156.36A.47.47 0 0 1 5-9H4v8h1c.133 0 .25.055.344.156.101.094.156.211.156.344q0 .204-.14.344l-2 2.015A.53.53 0 0 1 3 2a.47.47 0 0 1-.344-.14l-2-2.016A.44.44 0 0 1 .5-.5q0-.201.14-.344A.5.5 0 0 1 1-1h1v-8H1a.52.52 0 0 1-.36-.14.52.52 0 0 1-.14-.36q-.001-.2.156-.36l2-2A.47.47 0 0 1 3-12q.2 0 .36.14zm0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(-.5 12)"
    />
  ),
  svgProps: {
    height: "14",
    width: "5",
  }
};